import React, { useRef, useState } from 'react';

import Layout from '../../components/Layout';
import { PageContainer } from '../../components/shared';
import XoeChat from '../../components/xoe/XoeChat';
import { getLastActiveXoeConversation, useXoeChatSession } from '../../hooks/xoe/useXoeChatSession';
import { useFillHeight } from '../research/useFillHeight';

const RAIL_STORAGE_KEY = 'mg-xoe-rail-collapsed';

const XoeAssistantPage: React.FC = () => {
	const chatRef = useRef<HTMLDivElement>(null);
	const chatHeight = useFillHeight(chatRef);

	// Read once, so the page continues the conversation the floating panel was on (Maximise lands here).
	const [initialUuid] = useState(getLastActiveXoeConversation);
	const session = useXoeChatSession({ active: true, initialUuid });

	const title = session.activeUuid
		? session.activeDetail?.conversation.title || 'Conversation'
		: 'New conversation';

	return (
		<Layout>
			<PageContainer data-testid="xoe-assistant-page" noGap>
				<div
					ref={chatRef}
					style={{ height: chatHeight, minHeight: 0, display: 'flex' }}
					data-testid="xoe-assistant-chat"
				>
					<XoeChat
						session={session}
						tone="neutral"
						title={title}
						railPersistKey={RAIL_STORAGE_KEY}
						className="mg-xoe--page"
						frameTestId="xoe-fullpage-panel"
					/>
				</div>
			</PageContainer>
		</Layout>
	);
};

export default XoeAssistantPage;
